import Box from "@mui/material/Box";

import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";

import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';

import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { findIndex, map } from "lodash";

import { getDefsByKeyId, getClassNames } from "../../../Js/Common";
import { makeStyles } from "@material-ui/core/styles";
import { updateDefs } from "../Services";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const SelectProductAssignToClass = (props) => {
    // Hooks
    const classes = useStyles();

    // Redux state
    const userInfo = useSelector((state) => state.loggedInUserInfo.userInfo);

    // State    
    const [productToClass, setProductToClass] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [mode, setMode] = useState('view');

    const [dropDownData, setDropDownData] = useState([]);
    const [selectedDropdownData, setSelectedDropdownData] = useState([]);
    const [errorSelectClass, setErrorSelectClass] = useState(null);    

    // React logic hooks
    useEffect(() => {
        innerFunction();
    }, [props.productId]);

    useEffect(() => {
        if (dropDownData.length > 0) {
            fetchProductToClass();
        }

    }, [dropDownData]);

    useEffect(() => {
        const secondFunction = async () => {
            await funSelectedData();
        }
        secondFunction();
    }, [selectedProduct]);

    const innerFunction = async () => {
        let allClasses = await getClassNames(userInfo.site_uuid);
        console.log("allClasses====>",allClasses);
        setDropDownData(allClasses);
    };

    const fetchProductToClass = async () => {
        let resProductToClass = await getDefsByKeyId('product_to_class', userInfo.site_uuid);
        console.log("resProductToClass======>",resProductToClass);
        setProductToClass(resProductToClass.data);

        let selectedProductObj = resProductToClass.data.keydata.find(function (obj) {
            return obj.productId === props.productId
        });
        console.log("selectedProductObj",selectedProductObj);
        
        setSelectedProduct(selectedProductObj);
        return;
    };

    const funSelectedData = async () => {
        let assignedClass = selectedProduct.assignedClass || [];
        let selectedData = [];
        if (assignedClass.length) {
            assignedClass.forEach((element, index) => {
                let objResult = dropDownData.find(o => o.id === element);
                selectedData.push(objResult);
            });
        }
        console.log("selectedData====>",selectedData);
        setSelectedDropdownData(selectedData);
    };

    // On autofill we get a stringified value.
    const handleOnChange = (itemData) => {
        let newData = [...selectedDropdownData];
        let fndIndx = findIndex(selectedDropdownData, { id: itemData.id });
        if (fndIndx == -1) {
            newData.push(itemData)
        } else {
            newData.splice(fndIndx, 1);
        }
        setSelectedDropdownData(newData);
    };
    
    const removeChip = (index) => {
        setErrorSelectClass(null);
        let newData = [...selectedDropdownData];
        newData.splice(index, 1);
        setSelectedDropdownData(newData);
    };

    const handleSubmit = async () => {
        if (selectedDropdownData.length == 0) {
            setErrorSelectClass('Minimum one class required!');
            return;
        } else {
            let newData = { ...selectedProduct };
            let arrSelectedClass = map(selectedDropdownData, 'id');
            newData.assignedClass = arrSelectedClass;
            newData.assignedTo = 'selection';

            let products = productToClass.keydata;
            let pos = findIndex(products, { 'productId': newData.productId });
            products[pos] = newData;

            let postData = {
                keydata: products
            };

            let response = await updateDefs(postData, productToClass.uid, productToClass.site_uuid);
            if (response.status == 200) {
                resetStatus();
                return props.successConfirmation(true);
            }
        }
    };

    const resetStatus = () => {
        setErrorSelectClass(null);
        setSelectedProduct('');
        setDropDownData([]);
        setSelectedDropdownData([]);
        setMode('view');
        innerFunction();
    };

    return (
        <>
            <Box sx={{ textAlign: 'right' }}>
                {(mode === 'view') && (
                    <Button
                        sx={{
                            backgroundColor: '#F5F5F5',
                            textTransform: 'inherit',
                            borderRadius: 10,
                            fontWeight: '500',
                            '&:hover': { backgroundColor: 'primary.main', color: '#FFFFFF' },'@media (min-width: 1636px)': { fontSize: '1.2rem' }
                        }}
                        onClick={() => { setMode('edit') }}
                    >
                        Edit
                    </Button>
                )}
                {(mode === 'edit') && (
                    <>
                        <Button
                            sx={{
                                backgroundColor: '#F5F5F5',
                                textTransform: 'inherit',
                                borderRadius: 10,
                                fontWeight: '500',
                                '&:hover': { backgroundColor: 'primary.main', color: '#FFFFFF' },'@media (min-width: 1636px)': { fontSize: '1.2rem' }
                            }}
                            onClick={handleSubmit}
                        >
                            Update
                        </Button>
                        <Button
                            sx={{
                                marginLeft: 1,
                                backgroundColor: '#F5F5F5',
                                textTransform: 'inherit',
                                borderRadius: 10,
                                fontWeight: '500',
                                '&:hover': { backgroundColor: 'primary.main', color: '#FFFFFF' },'@media (min-width: 1636px)': { fontSize: '1.2rem' }
                            }}
                            onClick={() => { resetStatus(); }}
                        >
                            Cancel
                        </Button>
                    </>
                )}
            </Box>
            <Box sx={{ mt: 3, pl: 5 }}>
                <Select
                    disabled={(mode === 'edit') ? false : true}
                    fullWidth
                    multiple
                    size='small'
                    value={selectedDropdownData}
                    sx={{ borderRadius: 10 }}
                    renderValue={(selected) => (
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                            {selected.map((item) => (
                                <Chip key={item.id} label={item.value} sx={{fontWeight: '500','@media (min-width: 1636px)': { fontSize: '1rem' }}}/>
                            ))}
                        </Box>
                    )}
                    MenuProps={MenuProps}
                >
                    {dropDownData.map((itemData, index) => (
                        <MenuItem key={`${index}_assign`} value={itemData} onClick={() => handleOnChange(itemData)}>
                            <Checkbox checked={selectedDropdownData.filter((item) => item.id === itemData.id).length > 0} />
                            <ListItemText primary={itemData.value} />
                        </MenuItem>
                    ))}
                </Select>
            </Box>

            {errorSelectClass &&
                <Box className={[classes.errorMessage]}>
                    <ListItemText primary={errorSelectClass} />
                </Box>
            }

            {selectedDropdownData && selectedDropdownData.length > 0 && (
                <Box sx={{ textAlign: 'left', mt: 1, pl: 5 }}>
                    {selectedDropdownData.map((nameData, index) => {
                        return (<Chip
                            key={`${index}_assignClass`}
                            sx={{ mx: 1, mt: 1, fontSize: '0.7rem', backgroundColor: '#F5F5F5', color: 'primary.main', fontWeight: 600,'@media (min-width: 1636px)': { fontSize: '1rem' } }}
                            label={nameData.value}
                            disabled={(mode === 'edit') ? false : true}
                            onDelete={() => { removeChip(index) }}
                            deleteIcon={<CloseIcon />}
                            size="small" />)

                    })}
                </Box>
            )}
            
        </>
    )
}
const useStyles = makeStyles({
    errorMessage: {
        color: "red"
    }
});
export default SelectProductAssignToClass;